export default __webpack_public_path__ + "static/media/26.e227add7.png";